/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Link_Expired_MsgInputs */



/**
* | output |
* | --- |
* | "The link may have expired or already been used." |
*
* @param {Auth_Verify_Link_Expired_MsgInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_link_expired_msg = /** @type {((inputs?: Auth_Verify_Link_Expired_MsgInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Link_Expired_MsgInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le lien a peut-être expiré ou a déjà été utilisé.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El enlace puede haber expirado o ya ha sido usado.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O link pode ter expirado ou já foi usado.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il link potrebbe essere scaduto o già utilizzato.")
	return /** @type {LocalizedString} */ ("The link may have expired or already been used.")
});